// extracted by mini-css-extract-plugin
export var active = "_co-c";
export var compactArrow = "_co-5";
export var container = "_co-0";
export var dot = "_co-b";
export var dotContainer = "_co-a";
export var hoverArrowButton = "_co-7";
export var hoverArrowContainer = "_co-6";
export var leftHoverArrowContainer = "_co-8 _co-6";
export var rightHoverArrowContainer = "_co-9 _co-6";
export var slide = "_co-4";
export var sliderContainer = "_co-1";
export var sliderContainerVisibleOverflow = "_co-2";
export var sliderOverflow = "_co-3";
export var vignetteBoth = "_co-f";
export var vignetteLeft = "_co-e";
export var vignetteRight = "_co-d";